import { render, staticRenderFns } from "./TaxConfiguration.vue?vue&type=template&id=8d5abd70&scoped=true"
import script from "./TaxConfiguration.vue?vue&type=script&lang=js"
export * from "./TaxConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TaxConfiguration.vue?vue&type=style&index=0&id=8d5abd70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5abd70",
  null
  
)

export default component.exports